import React, { useState, useEffect } from "react";
import { useField } from "formik";
import styles from "./ImageUploader.module.scss";
import crossBtn1 from "../../../static/icons/crossBtn1.svg";
import PhotoCrop from "../../PhotoCrop";
import plus from "../../../static/images/plus.png";
import imageIcon from "../../../static/icons/imageIcon.svg";
import PhotoCropRectangular from "../../PhotoCropRectangular/index";
import PhotoCropSquare from "../../PhotoCropSquare/index";
import PlusIcon from "../../../static/icons/PlusIcon22.svg";

const ImageUploader = ({
  placeholder,
  preview,
  closeButton,
  isCircled = true,
  withCrop,
  uploadPhoto,
  preloadPhoto,
  hideControls,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  const [croppedImage, setCroppedImage] = useState(false);
  const [canOpen, setCanOpen] = useState(false);
  const [image, setImage] = useState(() => {
    return field.value
      ? field.value.url
        ? field.value.url
        : URL.createObjectURL(field.value)
      : null;
  });

  useEffect(() => {
    if (preloadPhoto instanceof Blob) {
      setCroppedImage(true);
      const url_image = URL.createObjectURL(preloadPhoto);
      setImage(url_image);
      helpers.setValue(new File([preloadPhoto], "avatar.png"));
    }
  }, [preloadPhoto]);

  const attachImage = (event) => {
    const type = event.type;
    let image = null;
    if (type === "change") {
      image = [...event.target.files][0];
      setCanOpen(true);
    }
    helpers.setValue(image);
    setImage(URL.createObjectURL(image));
    setCroppedImage(false);
    event.preventDefault();
  };

  const resetValue = () => {
    helpers.setValue(null);
    setImage(null);
  };
  const onCloseCrop = () => {
    resetValue();
    setCroppedImage(true);
  };
  const onSaveCrop = (imgData) => {
    setImage(URL.createObjectURL(imgData.topopup));
    helpers.setValue(new File([imgData.tosave], "avatar.png"));
    setCroppedImage(true);
  };

  if (canOpen && image && !croppedImage) {
    if (props.hasOwnProperty("isRectangular")) {
      if (props.hasOwnProperty("isRectangular")) {
        return (
          <PhotoCropSquare
            image={image}
            onCloseCrop={onCloseCrop}
            onSaveCrop={onSaveCrop}
            setCroppedImage={setCroppedImage}
            isCircled={true}
            isPost={uploadPhoto}
            withCrop={withCrop}
          />
        );
      } else
        return (
          <PhotoCropRectangular
            image={image}
            onCloseCrop={onCloseCrop}
            onSaveCrop={onSaveCrop}
            setCroppedImage={setCroppedImage}
            isCircled={true}
            isPost={uploadPhoto}
            withCrop={withCrop}
          />
        );
    } else {
      return (
        <PhotoCrop
          image={image}
          onCloseCrop={onCloseCrop}
          onSaveCrop={onSaveCrop}
          setCroppedImage={setCroppedImage}
          isCircled={true}
          isPost={uploadPhoto}
          withCrop={withCrop}
        />
      );
    }
  }
  return (
    <>
      {props.label && <span className={styles.labelText}>{props.label}</span>}
      <label
        className={styles.ImageUploader}
        invalid={meta.touched ? meta.error : undefined}
        filled={field.value}
      >
        {field.value ? (
          uploadPhoto ? (
            <>
              <div className={styles.uploadImage}>
                <img src={image} alt="" width={423} height={431} />
              </div>
            </>
          ) : (
            <>
              <div
                className={styles.image}
                style={{
                  backgroundImage: `url(${image})`,
                }}
                alt=""
              />
              {closeButton && !hideControls && (
                <button
                  type="button"
                  className={styles.resetButton}
                  onClick={resetValue}
                >
                  <img src={crossBtn1} alt="crossBtn" />
                </button>
              )}
              {closeButton && hideControls && (
                <span aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="3" height="22" viewBox="0 0 3 22" fill="none">
                    <path d="M1.5 1.25L1.5 21.25" stroke="#0A0B0C" strokeWidth="1.2" strokeLinecap="round"/>
                  </svg>
                </span>
              )}
            </>
          )
        ) : preview ? (
          <img src={preview} alt="" />
        ) : (
          <>
            <div className={styles.labelText} data-label-text="labelBlock">
              {placeholder === "icon" ? (
                <img src={imageIcon} alt="icon" />
              ) : (
                <>
                  <img src={PlusIcon} alt="plus" className={styles.plusIcon} />
                  <span className={styles.imagePlaceholder}>
                    {placeholder || ""}
                  </span>
                </>
              )}
            </div>
          </>
        )}
        <input type="file" accept="image/*" onChange={attachImage} />
      </label>
    </>
  );
};
export default ImageUploader;
